<div class="o-grid o-grid--bottom">
	<div class="o-grid__cell o-grid__cell--w-33 u-hidden@up-to-md">
		<h1 class="c-text c-text--heading c-text--xl u-osb-lg">{{ 'Sidebar.Title.Chats' | translate }}</h1>
	</div>
	<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-67@md-and-up">
		<div class="o-grid o-grid--bottom o-grid--wrap u-osb-lg">
			<div class="o-grid__cell u-no-p u-hidden@up-to-md">
				<p id="selectedChatUserName" data-testid="selected-chat-user-name" class="c-text c-text--heading c-text--xl" *ngIf="vm.selectedChat">
					{{ vm.selectedChat?.privateChatFriend?.fullName }}
				</p>
			</div>
			<div *ngIf="vm.isMentalHealthServiceStatusLoaded && vm.isMentalHealthServiceProvider && !vm.mentalHealthServiceProviderActive" class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up u-no-p u-ost-md@up-to-md">
				<a id="activateMentalHealthServiceProviderButton" (click)="vm.activateMentalHealthServiceProvider()" target="_blank" class="c-button c-button--s2 c-button--fit" style="padding-right: 30px;">
					<img class="u-hidden@up-to-md" style="position:absolute;vertical-align:middle;left:12px;" src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/icons/icon_activate.svg"/>
					{{ 'Chats.Other.MentalHealthButton' | translate }}
				</a>
			</div>
			<div *ngIf="vm.isMentalHealthServiceStatusLoaded && vm.isMentalHealthServiceProvider && vm.mentalHealthServiceProviderActive" class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up u-no-p u-ost-md@up-to-md">
				<a id="deactivateMentalHealthServiceProviderButton" (click)="vm.deActivateMentalHealthServiceProvider()" target="_blank" class="c-button c-button--s8 c-button--fit" style="padding-right: 30px;">
					<img class="u-hidden@up-to-md" style="position:absolute;vertical-align:middle;left:12px;" src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/icons/icon_activate.svg"/>
					{{ 'Chats.Other.MentalHealthButton' | translate }}
				</a>
			</div>
			<div *ngIf="!vm.isMentalHealthServiceProvider" class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up u-no-p u-ost-md@up-to-md">
				<a id="avTestButton" href="{{ vm.avTestUrl }}" class="c-button c-button--s2 c-button--fit">{{ 'How_It_Works.Item5-2' | translate }}</a>
			</div>
		</div>
	</div>
</div>
<div class="o-grid c-switcher" [ngClass]="{'c-switcher--right': vm.selectedChat, 'c-switcher--smooth': vm.initialized}">
	<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up c-switcher__panel">
		<div class="c-card c-card--height-fixed">
			<div class="o-grid o-grid--column o-grid--fit" *ngIf="vm.initialized">
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<div class="c-content c-content--border-bottom">
						<form class="c-form">
							<div class="c-form__group c-form__group--icon u-osb-sm">
								<i class="o-icon o-icon--search c-form__icon" aria-hidden="true"></i>
								<input type="text" id="chatSearchInput" name="chatSearchInput" class="c-form__input c-form__input--sm" placeholder="{{ 'Chats.Other.Search_Placeholder' | translate }}" spellcheck="false" [(ngModel)]="vm.term">
							</div>
						</form>
						<p class="c-text c-text--sm c-text--bold">{{ 'Chats.Other.Expiry' | translate }}</p>
					</div>
				</div>
				<div class="o-grid__cell c-content c-content--scroll u-no-p">
					<div *ngIf="vm.hasVisibleChats() && vm.chats && !vm.loading">
						<div id="chatItem{{$index}}" class="c-content u-no-p" [ngClass]="{'c-content--border-bottom': !$last}" *ngFor="let chat of vm.getChatsFiltered() | sortChats ; let $index=index ; let $last = last" (click)="vm.selectChat(chat)">
							<item-chat [chat]="chat"></item-chat>
						</div>
					</div>
					<div class="c-content c-content--xxl" *ngIf="!vm.hasVisibleChats()">
						<item-no-content [isFluid]="true"></item-no-content>
					</div>
					<loader-overlay *ngIf="vm.loading"></loader-overlay>
				</div>
			</div>
		</div>
	</div>
	<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-67@md-and-up c-switcher__panel">
		<card-chat [(chat)]="vm.selectedChat"></card-chat>
	</div>
</div>
